<template>
  <div>
    <b-container>
      <b-row class="justify-content-end mt-5">
        <b-col class="text-left mt-5" md="6">
          <img src="@/assets/logo/logo.svg" class="img-fluid mt-md-5" />
        </b-col>
        <b-col class="text-center" md="6">
          <Login />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import Login from "@/components/Login.vue";
export default {
  components: { Login },
};
</script>
